import { render, staticRenderFns } from "./TheProfileHeader.vue?vue&type=template&id=de661e54&"
import script from "./TheProfileHeader.vue?vue&type=script&lang=js&"
export * from "./TheProfileHeader.vue?vue&type=script&lang=js&"
import style0 from "./TheProfileHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports